import axios from "axios";
import { UserStore, GlobalStore } from "stores";
import { refreshSession } from "api/auth";

// axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.baseURL = "https://api.dev2.fntworld.io/api/";

if (localStorage.getItem("companyAccess")) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("companyAccess")}`;
}
if (
  !localStorage.getItem("companyAccess") &&
  localStorage.getItem("accessToken")
) {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("accessToken")}`;
}

let isRefreshing = false;
let requestQueue: ((token: string) => void)[] = [];

const processQueue = (error: any, token: string | null = null) => {
  requestQueue.forEach((callback) => {
    if (token) {
      callback(token);
    } else {
      callback(null as any);
    }
  });
  requestQueue = [];
};

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest?.url?.includes("/auth/refresh")) {
      return Promise.reject(error);
    }

    if (error?.response?.status === 500) {
      GlobalStore.setError("Internal Server Error");
      return Promise.reject();
    }

    if (error?.message === "Network Error" && !error?.response) {
      if (error?.config?.url?.includes("coingecko.com")) {
        console.log("Coingecko CORS");
        return Promise.reject(error);
      }
      if (error?.config?.url?.includes("ws.dev.fntworld.io")) {
        console.log("socket error");
        return Promise.reject(error);
      }
      console.log("Network Error:", error);
      GlobalStore.setError("Network Error");
      if (error?.response?.status !== 401) {
        return Promise.reject(error);
      }
    }

    if (
      error?.response?.status === 403 &&
      error?.response?.data?.message === "User is blocked"
    ) {
      UserStore.logOut();
      return Promise.reject(error);
    }

    if (error?.response?.status !== 401) {
      console.log(error);
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      if (error?.config?.url?.includes("api.itez.com")) {
        console.log("Itez Error");
        return Promise.reject(error);
      }
      if (error?.config?.url?.includes("paybis.com")) {
        console.log("Paybis Error");
        return Promise.reject(error);
      }

      if (error?.config?.url?.includes("firebasedatabase")) {
        console.log("Copy Trade Error");
        return Promise.reject(error);
      }

      if (error?.response?.status === 401) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            requestQueue.push((token) => {
              if (token) {
                originalRequest.headers["Authorization"] = `Bearer ${token}`;
                resolve(axios(originalRequest));
              } else {
                reject(error);
              }
            });
          });
        }

        isRefreshing = true;

        return new Promise((resolve, reject) => {
          refreshSession()
            .then(() => {
              const newToken = localStorage.getItem("accessToken");
              originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
              processQueue(null, newToken);
              resolve(axios(originalRequest));
            })
            .catch((refreshError) => {
              processQueue(refreshError, null);
              UserStore.logOut();
              reject(refreshError);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }

      return Promise.reject(error);
    }
  }
);
